import React from 'react';

const EntryOfferSection = () => {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[960px] mx-auto">
        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 md:p-12 shadow-sm relative overflow-hidden">
          <div className="absolute top-0 right-0 bg-[#0077C8] text-white text-[10px] font-bold uppercase tracking-[0.2em] px-8 py-2 rounded-bl-xl shadow-lg">Phase 1 Entry Offer</div>
          <div className="grid md:grid-cols-2 gap-16 items-center relative z-10">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="material-symbols-outlined text-[#0077C8] text-3xl">rocket_launch</span>
                <h3 className="text-3xl font-extrabold text-[#050B15]">Provision 29 Readiness Sprint</h3>
              </div>
              <div className="flex items-center gap-2 text-[#0077C8] font-bold mb-6">
                <span className="material-symbols-outlined text-xl">schedule</span>
                <span>Duration: 4-6 weeks</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-4 text-sm font-semibold text-[#050B15]">
                  <span className="material-symbols-outlined text-[#22C55E] text-2xl">check_circle</span>
                  Baseline GAP Analysis vs. Provision 29
                </li>
                <li className="flex items-center gap-4 text-sm font-semibold text-[#050B15]">
                  <span className="material-symbols-outlined text-[#22C55E] text-2xl">check_circle</span>
                  Evidence Integrity & Soundness Audit
                </li>
                <li className="flex items-center gap-4 text-sm font-semibold text-[#050B15]">
                  <span className="material-symbols-outlined text-[#22C55E] text-2xl">check_circle</span>
                  Board-Ready Reporting Template
                </li>
                <li className="flex items-center gap-4 text-sm font-semibold text-[#050B15]">
                  <span className="material-symbols-outlined text-[#22C55E] text-2xl">check_circle</span>
                  Immediate Remediation Roadmap
                </li>
              </ul>
            </div>
            <div className="flex flex-col gap-5 text-center">
              <button 
                className="bg-[#0077C8] text-white w-full py-5 rounded-xl font-bold text-lg hover:shadow-2xl hover:brightness-110 transition-all shadow-xl shadow-[#0077C8]/20"
                onClick={() => {
                  window.location.href = "mailto:john@dagalagroup.com?subject=Provision 29 Readiness Call";
                }}
              >
                Book a Provision 29 Readiness Call
              </button>
              <p className="text-xs text-gray-500 font-medium italic">Fixed-scope engagement for immediate clarity.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EntryOfferSection;
